import { RootState } from 'store';

export const activeMenuItemSelector = (state: RootState): string => state.menu.activeItemName;
